"use strict";
/* globals module */
/**
 * @module keyValueRoute
 * @description Baasic Key Value Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Key Value Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../common");
;
var contracts_1 = require("../../core/contracts");
var KeyValueRoute = /** @class */ (function (_super) {
    tslib_1.__extends(KeyValueRoute, _super);
    function KeyValueRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'key-values/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'key-values/{id}/{?embed,fields}';
        _this.createRoute = 'key-values';
        _this.updateRoute = 'key-values/{id}';
        _this.deleteRoute = 'key-values/{id}';
        return _this;
    }
    /**
     * Parses find key value route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify key value resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain key value subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the key value property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example keyValueRoute.find(options);
     **/
    KeyValueRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get key value route which must be expanded with the Id of the previously created key value resource in the system.
     * @method
     * @param id Key value resource unique identifier.
     * @param options Query resource options object.
     * @example keyValueRoute.get();
     **/
    KeyValueRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create key value route; this URI template does not expose any additional options.
     * @method
     * @example keyValueRoute.create();
     **/
    KeyValueRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update key value route.
     * @method
     * @param data Key Value object used to create update route.
     * @example keyValueRoute.update(data);
     */
    KeyValueRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete key value route.
     * @method
     * @param data Key Value object used to create delete route.
     * @example keyValueRoute.delete(data);
     */
    KeyValueRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a;
    KeyValueRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], KeyValueRoute);
    return KeyValueRoute;
}(common_1.BaseRoute));
exports.KeyValueRoute = KeyValueRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
